import axios from 'axios'
import qs from 'query-string'
import Vue from 'vue'
import VueRouter from 'vue-router'
import moment from 'moment'
import store from '@/store/store'
import router from '@/router/index'
import iView from 'iview';

Vue.use(VueRouter);

iView.Message.config({
  duration: 3,
  top: 500,
});



const URL_BASE = process.env.API_URL_BASE;
const hasBody = {
  get: false,
  post: true,
  patch: true,
  put: true,
  delete: true
};

const deepFormatDates = (obj) => {
  if (!obj && obj !== 0 && obj !== false) {
    return obj;
  }

  switch (obj.constructor) {
    case Date:
      return moment(obj).toISOString(true);
    case Number:
    case String:
    case Boolean:
      return obj;
    case Array:
      return obj.map(deepFormatDates);
    default:
      return Object.entries(obj).map(([key, value]) => [key, deepFormatDates(value)])
        .reduce((acc, [key, value]) => Object.assign(acc, {[key]: value}), {});
  }
};

const request = function (method, path, params, options,isRequireLoading) {
  //false 为默认共同的弹出框
  if (!options) options = {silent: false};
  if(!isRequireLoading) {
    store.commit("setLoadingShow", true);
  }else{
    store.commit("setLoadingShow", false);

  }
  let url = `${URL_BASE}${path}`;
  params = deepFormatDates(params);

  if (!hasBody[method]) {
    url = `${url}?${qs.stringify(params)}`;
  }

  let currentUser = window.sessionStorage.getItem('currentUser');
  if (currentUser) currentUser = JSON.parse(currentUser);
  let token = currentUser && currentUser.token;


  return axios({
    method: method,
    url: url,
    data: hasBody[method] ? params : undefined,
    headers: {token: token},
    withCredentials: true,
    // timeout: 100,
  }).catch((error) => {
    store.commit("setLoadingShow", false);
    if (error.response.status === 401 || error.response.status === 403) {
      store.commit("setLogoutShow", true);
      // setTimeout(function () {
        router.push({
          name:'login'
        },0)
      // });
    }
    throw error;
  }).then(resp => {
    store.commit("setLoadingShow", false);
    if (resp.data.code === 0) {
      // if (method !== 'get' && !options.silent) store.dispatch('putInfo', '操作成功');
      if (method !== 'get' && !options.silent) iView.Message.success('操作成功');
      return resp.data.data;
    } else {
      // if (!options.silent) store.dispatch('putError', resp.data.message);
      if (!options.silent) iView.Message.error(resp.data.message);

      let err = new Error(resp.data.message);
      err._response = resp;
      throw err;
    }
  })
};


export default Object.keys(hasBody)
  .map(method => [method, (path, params, options,isRequireLoading) => request(method, path, params, options,isRequireLoading)])
  .reduce(function (obj, [method, f]) {
    obj[method] = f;
    return obj;
  }, {});



// WEBPACK FOOTER //
// ./src/api/ApiClient.js